/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import LinkWrapper from 'helpers/SitecoreWrappers/LinkWrapper/LinkWrapper';
import { parseStyleParams } from 'lib/utils/style-param-utils';
import { getCtaStyle } from 'lib/utils/cta-utils';
import { getTestProps } from 'lib/testing/utils';
import { createCTAClickGTMEvent } from 'lib/utils/gtm-utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
import useIsEditing from 'lib/hooks/useIsEditing';
const ServiceBannerItem = (props)=>{
    const isEditing = useIsEditing();
    const { itemTitle, serviceLink1, serviceLink2, serviceLink3, serviceLink4, viewAllLink } = props?.fields || {};
    const { RenderingIdentifier } = props?.params || {};
    const styles = parseStyleParams(props?.params, [
        'cta1',
        'cta2',
        'cta3',
        'cta4',
        'cta5'
    ]);
    const { container, content, heading: headingTV, ctaLinksBlock, footer, buttonDivider, footerCtaLinksBlock, cta } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsxs("article", {
        className: container(),
        "data-component": "authorable/shared/lists/servicebanneritem",
        ...editingHydrationProps(isEditing),
        id: RenderingIdentifier,
        ...getTestProps(`component-servicebanneritem-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: content(),
                children: [
                    /*#__PURE__*/ _jsx(PlainTextWrapper, {
                        className: headingTV(),
                        field: itemTitle,
                        tag: "h3",
                        ...getTestProps('heading')
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: ctaLinksBlock(),
                        children: [
                            /*#__PURE__*/ _jsx(LinkWrapper, {
                                ctaComponentClass: "component-card-item-button-1-color",
                                className: cta(),
                                ctaStyle: getCtaStyle(styles.cta1, 'tertiary'),
                                field: serviceLink1,
                                ctaIcon: "arrow-right",
                                ...getTestProps('cta')
                            }),
                            /*#__PURE__*/ _jsx(LinkWrapper, {
                                ctaComponentClass: "component-card-item-button-1-color",
                                className: cta(),
                                ctaStyle: getCtaStyle(styles.cta2, 'tertiary'),
                                field: serviceLink2,
                                ctaIcon: "arrow-right",
                                ...getTestProps('cta')
                            }),
                            /*#__PURE__*/ _jsx(LinkWrapper, {
                                ctaComponentClass: "component-card-item-button-1-color",
                                className: cta(),
                                ctaStyle: getCtaStyle(styles.cta3, 'tertiary'),
                                field: serviceLink3,
                                ctaIcon: "arrow-right",
                                ...getTestProps('cta')
                            }),
                            /*#__PURE__*/ _jsx(LinkWrapper, {
                                ctaComponentClass: "component-card-item-button-1-color",
                                className: cta(),
                                ctaStyle: getCtaStyle(styles.cta4, 'tertiary'),
                                field: serviceLink4,
                                ctaIcon: "arrow-right",
                                ...getTestProps('cta')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: footer(),
                children: [
                    /*#__PURE__*/ _jsx("span", {
                        className: buttonDivider()
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: footerCtaLinksBlock(),
                        children: /*#__PURE__*/ _jsx(LinkWrapper, {
                            ctaComponentClass: "component-card-item-button-1-color",
                            className: cta(),
                            ctaStyle: getCtaStyle(styles.cta5, 'primaryOnCanvas'),
                            field: viewAllLink,
                            ctaIcon: "arrow-right",
                            ...getTestProps('cta'),
                            gtmEvent: createCTAClickGTMEvent({
                                header: itemTitle?.value,
                                ctaText: viewAllLink?.value?.text,
                                ctaType: 'blue',
                                componentName: 'Services Banner',
                                ctaLink: viewAllLink?.value?.href
                            })
                        })
                    })
                ]
            })
        ]
    });
};
export const Default = withStandardComponentWrapper(ServiceBannerItem);
const TAILWIND_VARIANTS = tv({
    slots: {
        container: [
            'flex',
            'flex-col',
            'justify-between',
            'h-full',
            'w-full',
            'rounded-general-border-radius-card',
            'bg-component-card-item-surface',
            'shadow-color-black-alpha-10',
            'shadow-[0_0_8px_0]',
            'bg-component-service-card-list-surface'
        ],
        content: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'text-left',
            'px-component-card-item-landscape-content-1-col-padding-x',
            'py-component-card-item-landscape-content-1-col-padding-y'
        ],
        heading: [
            'font-typography-font-family-header',
            'text-typography-font-size-medium',
            'text-component-card-item-title',
            'leading-typography-line-height-medium'
        ],
        ctaLinksBlock: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-4'
        ],
        footer: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'w-full',
            'px-component-card-item-landscape-content-1-col-padding-x',
            'pb-component-card-item-landscape-content-1-col-padding-y'
        ],
        buttonDivider: [
            'w-component-section-divider-width',
            'h-component-section-divider-height',
            'bg-component-section-divider'
        ],
        footerCtaLinksBlock: [
            'flex',
            'flex-start',
            'gap-spacing-spacing-4'
        ],
        cta: [
            '!w-auto',
            'gap-spacing-spacing-8',
            'items-center',
            'justify-between',
            'p-spacing-spacing-2'
        ]
    }
});
